import styles from '/builds/servicebund/servicebund-websites/.build/releases/1/DistributionPackages/Servicebund.RodeoSteakDe/Resources/Private/Fusion/Presentation/Composite/Header/Header.css';

export const prototypeName = 'Servicebund.RodeoSteakDe:Component.Header';
export {styles};